import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { StoreService } from 'src/app/services/store.service';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { decompress } from 'lz-string';
import { BehaviorSubject, combineLatest, filter, map, Observable, startWith, Subject, take, takeUntil } from 'rxjs';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { Users } from 'src/app/Interfaces/users';
import { UtilService } from 'src/app/services/util.service';
import { Time } from 'src/app/Utility/constants';
import { AgentPerDay, AgentPerDayWithSingleDay, TotalAgentPerDay, VisitsPlannedVsUnplanned } from 'src/app/Interfaces/SQL-reports-responses';
import { environment } from 'src/environments/environment';
import { LoadingService } from 'src/app/services/loading.service';
import { VisitsService } from 'src/app/services/visits.service';
import { sumOfKeyInData } from 'src/app/Utility/functions';
import { translateDateForSQLServer } from 'src/app/Utility/date_functions/SQL_ISO_adapter';

@Component({
	selector: 'app-admin-bizoa-azmanot',
	templateUrl: './admin-bizoa-azmanot.component.html',
	styleUrls: ['./admin-bizoa-azmanot.component.scss'],
})
export class AdminbizoaazmanotComponent implements OnInit, OnDestroy {
	_ss = inject(StoreService);
	router = inject(Router);
	_util = inject(UtilService);
	_visits = inject(VisitsService);
	private fb = inject(FormBuilder);
	private acr = inject(ActivatedRoute);
	private _loading = inject(LoadingService);

	constructor() {}

	AgentPerDate: AgentPerDay[];
	AgentPerDateOne: AgentPerDayWithSingleDay[];
	AdminSeeAgents: TotalAgentPerDay[];
	AdminSeeAgentsMain: TotalAgentPerDay[];

	HasMultipleCompanys;
	ShowCompanys;

	companyDictionary: Record<string | number, string> = {};

	agents = new FormControl<{ AgentID: string; UserName: string }[]>([]);
	companyControl = new FormControl<number>(0);

	form = this.fb.nonNullable.group({
		Date: [Intl.DateTimeFormat('en-IL', { year: 'numeric', month: 'numeric', day: 'numeric' }).format(new Date()).split('/').reverse().join('-')],
		ClientSearch: ['', Validators.required],
		agents: this.agents,
		from: [new Date(), Validators.required],
		to: [new Date(), Validators.required],
	});

	TodayDate = new Date();

	shouldShowCompanies = 0;

	agentsToGet = [];

	datesFilter = [new Date().toISOString().slice(0, 10)];

	dateFilterFunction = (date: Date): boolean => {
		const dates = this.datesFilter;

		return date ? dates.includes(date.toISOString().slice(0, 10)) : false;
	};

	destroy$ = new Subject<void>();

	goToDateOfAgent: { agent?: string; date?: string } = {};

	pageMode$ = new BehaviorSubject<'daily-sales' | 'planned-vs-unplanned'>('daily-sales');

	title$: Observable<string>;
	showSearch$: Observable<boolean>;
	totalSum$ = new BehaviorSubject(0);
	totalSumDisplay$: Observable<number> = this.totalSum$.asObservable();

	agentAndDaySelected$ = new BehaviorSubject<{ AgentID: string; UserName: string; dateString: string; company: number } | null>(null);

	currentlyViewedAgent = '';
	currentlyViewedClientTeuda = '';

	checkedArray = [];
	checkedArray$ = new BehaviorSubject(sumOfKeyInData({ data: this.checkedArray, keyToSum: 'COD' }));

	todayCutDate = Intl.DateTimeFormat('en-IL', { year: 'numeric', month: 'numeric', day: 'numeric' }).format(new Date()).split('/').reverse().join('-');

	isVisitsPlannedVsUnplanned = location.pathname.includes('planned-vs-unplanned');
	visits: VisitsPlannedVsUnplanned[] = [];
	visits$ = new BehaviorSubject<VisitsPlannedVsUnplanned[]>([]);
	visitsDisplay$ = this.visits$.pipe(map(visits => visits.filter(visit => new Date(visit.docdate).toISOString().slice(0, 10) === this.todayCutDate)));

	maxVisitsLength = environment.production ? 0 : 0;

	showDateSelection$ = this._visits.isViewingSpecificAgentAndStatus$.pipe(map(isViewing => !isViewing));

	async ngOnInit() {
		if (this.isVisitsPlannedVsUnplanned) {
			this.pageMode$.next('planned-vs-unplanned');
		}

		this.acr.queryParams.pipe(takeUntil(this.destroy$)).subscribe(params => {
			for (const key in params) {
				if (Object.prototype.hasOwnProperty.call(params, key)) {
					this.goToDateOfAgent[key] = params[key];
				}
			}

			this.form.controls.Date.setValue(this.goToDateOfAgent.date);
		});

		//////////////////// ---------- CLIENT INFORMATION ---------- ////////////////////
		if (this._ss.CustomerInformation === null) {
			if (localStorage.getItem('CustomerInformation') !== null) {
				this._ss.CustomerInformation = decompress(localStorage.getItem('CustomerInformation'));
				this._ss.CustomerInformation = JSON.parse(this._ss.CustomerInformation);
			}
		}

		const username = localStorage.getItem('UserName');
		const agentid = localStorage.getItem('AgentId');

		if (!username || !agentid) {
			this.router.navigate(['login']);
			return;
		}

		this._ss.UserNameConnected = localStorage.getItem('UserName');
		this._ss.AgentIdConnected = localStorage.getItem('AgentId');

		this.HasMultipleCompanys = localStorage.getItem('HasMultipleCompanys');

		if (this._ss.CustomerInformation.HasMultipleCompanies !== '0') {
			this.HasMultipleCompanys = Number(this._ss.CustomerInformation.HasMultipleCompanies) + 1;
		}

		if (this.HasMultipleCompanys > 1) {
			await new Promise<void>(resolve => {
				this._ss.GetCompaniesWithoutAgent().subscribe({
					next: res => {
						if (typeof res !== 'string' && res.recordset && res.recordset.length) {
							this.ShowCompanys = res.recordset;
							localStorage.setItem('ShowCompanys', JSON.stringify(this.ShowCompanys));
						} else {
							this.ShowCompanys = [{ Company: 1, CompanyName: this._ss.CustomerInformation.CustName }];
						}
						resolve();
					},
					error: err => {
						resolve();
					},
				});
			});

			if (!this.ShowCompanys) {
				if (localStorage.getItem('ShowCompanys') !== null) {
					this.ShowCompanys = localStorage.getItem('ShowCompanys');
					this.ShowCompanys = JSON.parse(this.ShowCompanys);
					this.ShowCompanys.sort((a, b) => a.Company - b.Company);
				} else {
					this._ss.GetComppanys().subscribe(res => {
						this.ShowCompanys = res;
						this.ShowCompanys = this.ShowCompanys.recordset;
						this.ShowCompanys.sort((a, b) => a.Company - b.Company);
						localStorage.setItem('ShowCompanys', JSON.stringify(this.ShowCompanys));
					});
				}
			}
		} else {
			this.ShowCompanys = [{ Company: 1, CompanyName: this._ss.CustomerInformation.CustName }];
		}

		this.companyDictionary = this.ShowCompanys.reduce((acc, curr) => ({ ...acc, [curr.Company]: curr.CompanyName }), {});

		this.setupPipes();
		this.setupPlannedVsUnplannedInteractivity();

		//////////////////// ---------- CLIENT INFORMATION ---------- ////////////////////

		// this.dropdownSettings = {
		// 	idField: 'AgentID',
		// 	textField: 'UserName',
		// 	selectAllText: 'סמן הכל',
		// 	unSelectAllText: 'הוצא סימון',
		// 	itemsShowLimit: 1,
		// };

		if (this.isVisitsPlannedVsUnplanned) {
			if (this._visits.chosenLineToView$.value) {
				return;
			}
			this.getPlannedVsUnplannedVisits();
			return;
		}

		if (this._ss.CustomerInformation.Submanagers !== '1') {
			this.getAgentList();
			return;
		}

		if (this._ss.agentsOfSubmanager.length) {
			this.agentsToGet = this._ss.agentsOfSubmanager;
			this.getAgentList();
			return;
		}

		this._ss.getAdminAgents().subscribe({
			next: res => {
				if (typeof res == 'string') {
					alert('חלה תקלה בהבאת סוכנים עבור מנהל זה. נסו שנית');
					return;
				}

				this.agentsToGet = res.recordset.map(obj => obj.Agent);
				this.agentsToGet.push(this._ss.AgentIdConnected);

				this.getAgentList();
			},
			error: err => {
				alert('שגיאת תקשורת');
			},
		});
	}

	ngOnDestroy(): void {
		this._loading.changeLoadingStatuses({ isLoading: false });
		this._visits.resetChosenLineState();
		this.destroy$.next();
		this.destroy$.complete();
	}

	public ChooseDate() {
		if (this.pageMode$.value === 'planned-vs-unplanned' || this.form.controls.from.invalid || this.form.controls.to.invalid) return;

		this.AdminSeeAgents = [];

		let { from, to } = this.form.value;

		if (this.goToDateOfAgent.date) {
			from = new Date(this.goToDateOfAgent.date);
			to = new Date(this.goToDateOfAgent.date);
		}

		this.First = true;
		this.Second = false;
		this.Third = false;
		// this.Fourth = false;

		let total = 0;

		if (from.getTime() === to.getTime()) {
			const fixedDate = translateDateForSQLServer(new Date(this.form.controls.from.value));
			for (let x = 0; x < this.AdminSeeAgentsMain.length; x++) {
				if (this.AdminSeeAgentsMain[x].td.toString().slice(0, 10) === fixedDate.toISOString().slice(0, 10)) {
					this.AdminSeeAgents.push(this.AdminSeeAgentsMain[x]);
					total += this.AdminSeeAgentsMain[x].sum1;
				}
			}
		} else {
			from = translateDateForSQLServer(from);
			to = new Date(translateDateForSQLServer(to).getTime() + Time.hour);
			for (let x = 0; x < this.AdminSeeAgentsMain.length; x++) {
				if (new Date(this.AdminSeeAgentsMain[x].td) >= from && new Date(this.AdminSeeAgentsMain[x].td) <= to) {
					this.AdminSeeAgents.push(this.AdminSeeAgentsMain[x]);
					total += this.AdminSeeAgentsMain[x].sum1;
				}
			}
		}
		this.totalSum$.next(total);
	}

	public ResetDate() {
		this.AdminSeeAgents = this.AdminSeeAgentsMain;
		this.form.controls.Date.reset();
		this.form.controls.from.reset();
		this.form.controls.to.reset();

		this.First = true;
		this.Second = false;
		this.Third = false;
		// this.Fourth = false;

		this.totalSum$.next(sumOfKeyInData({ data: this.AdminSeeAgents as any[], keyToSum: 'sum1' }));
	}

	public First = true;
	public Second = false;
	public Third = false;
	// public Fourth = false;

	public BackToAdmin() {
		if (this.First === true) {
			// this.router.navigate(['admin'])
			history.back();
		}

		if (this.Second === true) {
			this.First = true;
			this.Second = false;

			switch (this.pageMode$.value) {
				default:
				case 'planned-vs-unplanned':
					break;

				case 'daily-sales':
					this.totalSum$.next(sumOfKeyInData({ data: this.AdminSeeAgents as any[], keyToSum: 'sum1' }));
					break;
			}
		}

		if (this.Third === true) {
			this.Second = true;
			this.Third = false;

			switch (this.pageMode$.value) {
				default:
				case 'planned-vs-unplanned':
					break;

				case 'daily-sales':
					this.totalSum$.next(sumOfKeyInData({ data: this.AgentPerDate, keyToSum: 'sum1' }));
					break;
			}
		}

		// if (this.Fourth === true) {
		// 	this.Third = true;
		// 	this.Fourth = false;
		// }
	}

	public GetSpecificAgentAndDay(ag, agn, td, cm) {
		this.First = false;
		this.Second = true;
		this.AgentPerDate = [];

		this.currentlyViewedAgent = `${ag} - ${agn}`;

		this.agentAndDaySelected$.next({ AgentID: ag, UserName: agn, dateString: td, company: cm });

		this._ss.GetSpecificAgentAndDayService(ag, td, cm).subscribe({
			next: (res: any) => {
				if (!res.recordset || !res.recordset.length) {
					alert('לא נמצאו נתונים לתאריך זה');
					this.First = true;
					this.Second = false;
					return;
				}

				this.AgentPerDate = res.recordset;

				this.totalSum$.next(sumOfKeyInData({ data: this.AgentPerDate, keyToSum: 'sum1' }));
			},
			error: err => {
				alert('שגיאת שרת');
				this.First = true;
				this.Second = false;
				return;
			},
		});
	}
	public GetOneAzmanaAgentAdmonDate({ teudaNumber, clientName, totalSum }: { teudaNumber: string; clientName: string; totalSum: number }) {
		this.currentlyViewedClientTeuda = clientName;
		this.Second = false;
		this.Third = true;
		this.AgentPerDateOne = [];

		this._ss.GetOneAzmanaAgentAdmonDateService(teudaNumber).subscribe(res => {
			if (typeof res === 'string' || !res.recordset) {
				alert('ישנה תקלת תקשורת. נסו שנית מאוחר יותר');
				return history.back();
			}
			this.AgentPerDateOne = res.recordset.map(one => ({ ...one, net: one.prc * (1 - one.dsc / 100) }));

			this.totalSum$.next(totalSum);
		});
	}

	async getAgentList() {
		// await this.handleGetAgentsList();
		this._ss
			.getTotalForAgentPerDay(this.agentsToGet)
			.pipe(takeUntil(this.destroy$))
			.subscribe({
				next: res => {
					if (typeof res === 'string' || !res.recordset || !res.recordset.length) {
						alert('ישנה תקלת תקשורת. נסו שנית מאוחר יותר');
						return history.back();
					}

					this.AdminSeeAgents = [];
					this.AdminSeeAgentsMain = res.recordset;

					const companiesSet: Set<number> = new Set();
					const datesSet: Set<string> = new Set();

					const todayCutDate = Intl.DateTimeFormat('en-IL', { year: 'numeric', month: 'numeric', day: 'numeric' }).format(new Date()).split('/').reverse().join('-');

					for (let x = 0; x < this.AdminSeeAgentsMain.length; x++) {
						companiesSet.add(this.AdminSeeAgentsMain[x].cm);

						const fixedDate = new Date(new Date(this.AdminSeeAgentsMain[x].td).getTime() + new Date().getTimezoneOffset() * Time.minuteInMilliseconds);

						datesSet.add(fixedDate.toISOString().slice(0, 10));

						const unchangedDate = new Date(this.AdminSeeAgentsMain[x].td).toISOString().slice(0, 10);

						if (unchangedDate === todayCutDate) {
							this.AdminSeeAgents.push(this.AdminSeeAgentsMain[x]);
						}
					}

					this.totalSum$.next(sumOfKeyInData({ data: this.AdminSeeAgents as any[], keyToSum: 'sum1' }));

					this.datesFilter = [...datesSet];

					this.shouldShowCompanies = [...companiesSet].length;

					if (this.goToDateOfAgent.agent && this.goToDateOfAgent.date) {
						const ag = this.AdminSeeAgentsMain.find(am => am.ag === this.goToDateOfAgent.agent);
						this.ChooseDate();
						this.GetSpecificAgentAndDay(this.goToDateOfAgent.agent, ag.agn, new Date(this.goToDateOfAgent.date).toISOString(), 1);
					}
				},
				error: err => {
					alert('ישנה תקלת תקשורת. נסו שנית מאוחר יותר');
					history.back();
				},
			});
	}

	SearchClear() {
		this.form.controls.ClientSearch.reset();
	}

	async getAgentsList() {
		return await new Promise<Users[]>((resolve, rej) => {
			this._ss
				.GetAllAgents()
				.pipe(takeUntil(this.destroy$))
				.subscribe({
					next: res => {
						if (typeof res === 'object' && res.recordset) {
							res.recordset.sort((a, b) => +a.AgentID - +b.AgentID);
							return resolve(res.recordset);
						}

						rej();
					},
					error: err => {
						console.log({ err });
						rej();
					},
				});
		});
	}

	getPlannedVsUnplannedVisits() {
		this._ss
			.getPlannedVsUnplannedReport()
			.pipe(takeUntil(this.destroy$))
			.subscribe({
				next: res => {
					if (typeof res === 'string' || !res.recordset?.length) {
						alert('ישנה תקלת תקשורת. נסו שנית מאוחר יותר');
						return history.back();
					}

					this.AdminSeeAgents = [];
					this.AdminSeeAgentsMain = [];
					// this.AdminSeeAgentsMain = this.AdminSeeAgents;

					const companiesSet: Set<number> = new Set();
					const datesSet: Set<string> = new Set();

					for (let x = 0; x < res.recordset.length; x++) {
						const visit = res.recordset[x];
						companiesSet.add(visit.company);

						const fixedDate = new Date(new Date(visit.docdate).getTime() + new Date().getTimezoneOffset() * Time.minuteInMilliseconds);

						datesSet.add(fixedDate.toISOString().slice(0, 10));
					}

					this.visits = res.recordset;
					this.visits$.next(this.visits);

					this.datesFilter = [...datesSet];

					this.shouldShowCompanies = [...companiesSet].length;

					// if (this.goToDateOfAgent.agent && this.goToDateOfAgent.date) {
					// 	const ag = this.AdminSeeAgentsMain.find(am => am.ag === this.goToDateOfAgent.agent);
					// 	this.ChooseDate();
					// 	this.GetSpecificAgentAndDay(this.goToDateOfAgent.agent, ag.agn, new Date(this.goToDateOfAgent.date).toISOString(), 1);
					// }
				},
				error: err => {
					alert('ישנה תקלת תקשורת. נסו שנית מאוחר יותר');
					history.back();
				},
			});
	}

	handleAdvancedSearch(action: 'clear' | 'all' | 'single') {
		this.form.controls.ClientSearch.setValue('');

		// if (action !== 'single') {
		// 	this.AllClients = this.AllClientsSearch;
		// } else {
		// 	if (this.agents.value && this.agents.value.length) {
		// 		this.AllClients = this.AllClientsSearch.filter(client => {
		// 			for (const a of client.agent) {
		// 				if (this.agents.value.find(ag => ag.AgentID === a)) {
		// 					return true;
		// 				}
		// 			}
		// 			return false;
		// 		});
		// 	}
		// }

		// this.refreshSubjects('allClientsSum');
	}

	handleCheck(client) {
		const included = this.checkedArray.findIndex(checked => checked.ClientId === client.ClientId);
		if (included > -1) {
			this.checkedArray.splice(included, 1);
		} else {
			this.checkedArray.push(client);
		}
		this.checkedArray$.next(sumOfKeyInData({ data: this.checkedArray, keyToSum: 'COD' }));
	}

	valuesObject = {
		First: ['agn', 'ag', 'sum1', 'td', 'cm'],
		Second: ['cn', 'cl', 'sum1', 'tn', 'dn'],
		Third: ['itn', 'it', 'qt', 'pk', 'unt', 'prc', 'dsc', 'net', 'bns', 'rem'],
	} as const;

	translateForSort(value: typeof this.valuesObject[typeof screen][number], screen: keyof typeof this.valuesObject = Object.keys(this.valuesObject)[0] as keyof typeof this.valuesObject): void {
		let i: number, arrayToSort: any[];

		i = this.valuesObject[screen].findIndex(arr => arr === value);

		if (screen === 'First') {
			arrayToSort = this.AdminSeeAgents;
		}

		if (screen === 'Second') {
			arrayToSort = this.AgentPerDate;
		}

		if (screen === 'Third') {
			arrayToSort = this.AgentPerDateOne;
		}

		if (i === undefined || i === -1) {
			console.log('i should never show');
			return;
		}

		this._util.sortWithIndex(value, i, arrayToSort);
	}

	setupPipes() {
		this.title$ = this.pageMode$.pipe(
			map(page => {
				switch (page) {
					case 'daily-sales':
						return 'ביצועים הזמנות';
					case 'planned-vs-unplanned':
						return 'ביקורים - תיכנון מול ביצוע';

					default:
						return '';
				}
			}),
		);

		this.showSearch$ = this.pageMode$.pipe(
			map(page => {
				switch (page) {
					case 'daily-sales':
						return false;
					case 'planned-vs-unplanned':
						return true;

					default:
						return false;
				}
			}),
		);

		// this.totalSum$ = combineLatest([this.agentAndDaySelected$, this.pageMode$]).pipe(
		// 	map(([agentAndDaySelected, pageMode]) => {
		// 		if (pageMode === 'daily-sales') {
		// 			return this.Total;
		// 		}

		// 		if (pageMode === 'planned-vs-unplanned') {
		// 			return sumOfKeyInData({ data: this.AdminSeeAgents as any[], keyToSum: 'sum1' });
		// 		}

		// 		return 0;
		// 	}),
		// );
	}

	setupPlannedVsUnplannedInteractivity() {
		if (this.pageMode$.value !== 'planned-vs-unplanned') return;

		const searchValue$ = this.form.controls.ClientSearch.valueChanges.pipe(startWith(''));
		const dateValue$ = this.form.controls.Date.valueChanges.pipe(
			startWith(Intl.DateTimeFormat('en-IL', { year: 'numeric', month: 'numeric', day: 'numeric' }).format(new Date()).split('/').reverse().join('-')),
		);

		const allVisits$ = this._visits.chosenLineToView$.value ? this._visits.visits$.asObservable() : this.visits$;

		this.visitsDisplay$ = combineLatest([allVisits$, searchValue$, dateValue$]).pipe(
			map(([allVisits, searchValue, dateValue]: [VisitsPlannedVsUnplanned[], string, string | Date]) => {
				let filteredVisits: VisitsPlannedVsUnplanned[] = [...allVisits.slice(0, this.maxVisitsLength || allVisits.length)];
				const stringSearchArray: any[] = [];

				if (searchValue) {
					const splitValue = searchValue.split(' ');

					for (let i = 0; i < filteredVisits.length; i++) {
						let counter = 0;

						const { ClientID, clientname } = filteredVisits[i];

						const clientIDWithoutSpaces = (clientname || '').replace(/\s/g, '').toLowerCase(),
							clientNameWithoutSpaces = (ClientID || '').replace(/\s/g, '').toLowerCase(),
							allStrings = typeof clientIDWithoutSpaces === 'string' && typeof clientNameWithoutSpaces === 'string';

						// V8 optimizes this if statement, maybe
						if (allStrings) {
							for (let j = 0; j < splitValue.length; j++) {
								if ((clientIDWithoutSpaces && clientIDWithoutSpaces.indexOf(splitValue[j]) > -1) || (clientNameWithoutSpaces && clientNameWithoutSpaces.indexOf(splitValue[j]) > -1)) {
									counter++;
								}
							}

							if (counter >= splitValue.length) {
								stringSearchArray.push(filteredVisits[i]);
							}
						}
					}

					filteredVisits = stringSearchArray;
				}

				if (dateValue && !this._visits.chosenLineToView$.value) {
					if (typeof dateValue === 'string') {
						return (filteredVisits = filteredVisits.filter(visit => new Date(visit.docdate).toISOString().slice(0, 10) === this.todayCutDate));
					}
					let fixedDate = new Date(dateValue.getTime() - new Date().getTimezoneOffset() * Time.minuteInMilliseconds);

					filteredVisits = filteredVisits.filter(visit => new Date(visit.docdate).toISOString().slice(0, 10) === fixedDate.toISOString().slice(0, 10));
				}

				return filteredVisits;
			}),
		);

		this.totalSumDisplay$ = this.visitsDisplay$.pipe(map(visits => sumOfKeyInData({ data: visits, keyToSum: 'TeudaTotalSumBeforeVat' })));
	}
}
